import { render, staticRenderFns } from "./PassProtectedContent.vue?vue&type=template&id=5696979f"
import script from "./PassProtectedContent.vue?vue&type=script&lang=js"
export * from "./PassProtectedContent.vue?vue&type=script&lang=js"
import style0 from "./PassProtectedContent.vue?vue&type=style&index=0&id=5696979f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports